import { useDispatch } from 'react-redux';

import { openAIChat, setActiveWorkflow, ShiftImpactSource, WorkflowTypes } from 'handlers/aiChat';
import { clearShiftImpact } from 'handlers/shiftImpact';

interface OpenShiftImpactChatParams {
  shiftId: number;
  source?: ShiftImpactSource;
  shiftRequirementId?: number;
}

const useOpenShiftImpactChat = () => {
  const dispatch = useDispatch();

  return ({ shiftId, source = ShiftImpactSource.Dashboard, shiftRequirementId }: OpenShiftImpactChatParams) => {
    dispatch(clearShiftImpact());
    dispatch(openAIChat());
    dispatch(
      setActiveWorkflow({
        success: false,
        type: WorkflowTypes.ShiftImpact,
        shiftId,
        shiftRequirementId,
        shiftImpactSource: source,
      }),
    );
  };
};

export default useOpenShiftImpactChat;
